
interface CommunityHelpersHeaderProps {
  title: string;
}

const CommunityHelpersHeader = ({ title }: CommunityHelpersHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <h2 className="text-2xl font-bold">{title}</h2>
    </div>
  );
};

export default CommunityHelpersHeader;
